{ doAction, fail, success } = require './index'

REFRESH_TOKEN = 'REFRESH_TOKEN'

module.exports = {
	REFRESH_TOKEN

	refreshToken: (token) ->
		auth = JSON.parse(localStorage.getItem('auth'))
		auth.token = token
		localStorage.setItem 'auth', JSON.stringify(auth)
		return {
			type: REFRESH_TOKEN
			payload:
				token: token
		}
}



// WEBPACK FOOTER //
// ./frontend/olos/js/actions/token.coffee